// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ol-0";
export var discountCodeInput = "_ol-1";